import { getCookie } from "banco/util/cookies";

const LOGIN_CLASSES = [".show-logged-out", ".show-journey-session", ".show-logged-in"] as const;

const keepOnlyClass = (classToKeep: typeof LOGIN_CLASSES[number]): void => {
  LOGIN_CLASSES.forEach((loginClass) => {
    const elements = document.querySelectorAll(loginClass);
    elements.forEach((element) => {
      if (loginClass === classToKeep) {
        element.classList.add("in");
      } else {
        element.classList.remove("in");
      }
    });
  });
};

export const Navbar = {
  init: (): void => {
    const userLoggedIn = getCookie("user_logged_in");

    if (userLoggedIn === "customer") {
      keepOnlyClass(".show-logged-in");
    } else if (userLoggedIn === "journey") {
      keepOnlyClass(".show-journey-session");
    } else {
      keepOnlyClass(".show-logged-out");
    }

    document.addEventListener("scroll", () => {
      const navbar = document.querySelector(".navbar-light");
      if (navbar) {
        if (window.scrollY > 30) {
          navbar.classList.add("scrolled");
        } else {
          navbar.classList.remove("scrolled");
        }
      }
    });
  }
};

window.Navbar = Navbar;
